import styled from 'styled-components';
import { motion } from 'framer-motion';

export const NewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const NewsCard = styled.div`
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

export const NewsImageContainer = styled.div`
  overflow: hidden;
  position: relative;
  padding-top: 56.25%; // 16:9 aspect ratio
`;

export const NewsImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #f8f9fa;
  padding: 1rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const NewsContent = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const NewsDate = styled.p`
  font-size: 0.8rem;
  color: var(--text-color);
  margin-bottom: 0.5rem;
  opacity: 0.7;
`;

export const NewsHeadline = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
  color: var(--primary-color);
  line-height: 1.4;
`;

export const NewsSummary = styled.p`
  margin-bottom: 1.5rem;
  flex-grow: 1;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

export const NewsLink = styled.a`
  color: var(--primary-color);
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  transition: transform 0.3s ease;
  
  span {
    display: inline-block;
    transition: transform 0.3s ease;
  }
  
  &:hover {
    span {
      transform: translateX(5px);
    }
  }
`;

// Animation variants
export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.4
    }
  },
  hover: { 
    y: -10,
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.15)",
    transition: { 
      duration: 0.2 
    }
  }
}; 